module.exports = __webpack_public_path__ + "img/about_local_team_daily02.04728bbf.png";